import React from 'react';
import { useParams } from 'react-router-dom';
import {useQuery} from "@tanstack/react-query";
import { LabContext } from '../../../context/lab';
import Dex from './AccountDetailsUI';
import { fetchDexAccount } from '../../../services';
import LoadingWrapper from '../../../components/LoadingWraper';
import { IDexPropsData } from '../../../types/dex';
import CopyTxtIconBtn from '../../../components/CopyTxtIconBtn';
import SearchResultTitle from '../../../components/SearchResultTitle';

export default function AccountDetails(){
    const { account } = useParams();
    // const accountID = "6c51b9aa-64a2-4719-b6cb-9dc191e4019f";
    // const address = "7WBV3NpBEzdmJMtkK1A7u7fMVJxfwd9J3nboAENNo8xr";
    const {lab} = React.useContext(LabContext);

    const { isError, data, error, isFetching, isLoading, isSuccess } = useQuery(['dex-account', account],  async () => 
        await fetchDexAccount({nodeLab: lab!.nodeLab.toString(), accountID: account!, dexAddress: lab!.dexAddress}), {
            refetchOnWindowFocus: false,
            retry: 3
        }
    );    
      
    return (
        <div>
            <SearchResultTitle>
                Account: <CopyTxtIconBtn value={account || ""}/> {account}
            </SearchResultTitle>
            <LoadingWrapper
                child={data && <Dex data={data as IDexPropsData} />}
                isLoading = {isLoading || isFetching}
                error = {!!error || isError}
                isSucceeded={isSuccess && Object.keys(data).length > 0}
            />
        </div>
    );
}

